import { Component, inject, OnInit, signal } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgStyle } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from '../../../services/app.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ToastService } from '../../../services/toast.service';
import { DialogService } from '../../../services/dialog.service';
import { environment } from '../../../../../environments/environment';

interface PartnerLoginError extends Error {
  partnerLoginAttempt?: boolean;
}

@Component({
  selector: 'app-sign-in',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    NgStyle,
    TranslateModule,
    RouterLink,
    MatProgressSpinnerModule,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {
  signInForm!: FormGroup;
  fb = inject(FormBuilder);
  showPassword = signal<boolean>(false);
  router = inject(Router);
  appService = inject(AppService);
  authService = inject(AuthenticationService);
  isLoading = false;
  toastService = inject(ToastService);
  dialogService = inject(DialogService);

    // lifecycle hook
  ngOnInit() {
    this.signInForm = this.fb.group({
      email: new FormControl('', [
        Validators.required,
      ]),
      password: new FormControl('', [Validators.required]),
    });
  }
 get signInFormControl() {
    return this.signInForm.controls;
  }

  get emailControl() {
    return this.signInForm.get('email');
  }

  get passwordControl() {
    return this.signInForm.get('password');
  }

  // Method to sign in to customer portal.
  signIn() {
    this.isLoading = true;
    const payload = {
      EmailAddress: this.signInForm.get('email')?.value,
      Password: this.signInForm.get('password')?.value,
    };
    this.authService.login(payload).subscribe({
      next: () => {
        this.dialogService.closeAllDialog();
        this.router.navigate(['/customer-portal']);
      },
      error: (err: Error) => {
        this.isLoading = false;
        // Let the error propagate to the global error handler
        // if (err.message.toLowerCase().includes('email')) {
        //   this.signInForm.get('email')?.setErrors({ serverError: err.message });
        // } else if (err.message.toLowerCase().includes('password')) {
        //   this.signInForm
        //     .get('password')
        //     ?.setErrors({ serverError: err.message });
        // } else {
        //   this.toastService.openSnackbar({
        //     message: err.message,
        //     icon: 'error',
        //   });
        // }
        
        // Check if this is a partner login attempt error
        if ((err as PartnerLoginError).partnerLoginAttempt) {
          this.toastService.openSnackbar({
            message: err.message,
            icon: 'error',
            duration: 3000
          });
          // Redirect to partner portal after toast duration
          setTimeout(() => {
            try {
              window.location.replace(environment.portalUrl);
            } catch {
              // Fallback to href if replace fails
              window.location.href = environment.portalUrl;
            }
          }, 3000);
        } else {
          this.toastService.openSnackbar({
            message: err.message,
            icon: 'error',
          });
        }
        this.authService.logout();
        console.log(err);
        // throw err;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  // Opens customer type selection dialog box.
  navigateToSignUp() {
    this.dialogService.openSignUpCustomerTypeSelectionDialog();
  }

  // Closes dialog box and navigates to reset password screen. 
  navigateToResetPassword() {
    this.dialogService.closeAllDialog();
  }

  get labelPadding() {
    return this.emailControl?.hasError('serverError') ? '16px' : '0';
  }
}
